import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { ProgramSteps } from './OccasionalCreditCardInputEnumsAndVariables';

export const blackListValidation = createAsyncThunk('OccasionalCreditCardInput/blackListValidation', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('occasionalCreditCardInputBlackListValidation', [
      data.creditCardType,
      data.creditCardNumber,
      data.idNumber,
    ]);
    return result.Body;
  } catch (error) {
    return error;
  }
});
export const jetUpdateOpportunityCreditCard = createAsyncThunk(
  'OccasionalCreditCardInput/jetUpdateOpportunityCreditCard',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('jetUpdateOpportunityCreditCard', [
        data.creditCardNumber,
        data.expirationDate,
        data.idNumber,
        data.creditCardType,
        data.terminalNumber,
        data.authNumber,
        data.cardBrand,
        data.creditCompany,
        data.pymBlackList,
        data.capacityOverflow,
        data.delinquentCustomers,
      ]);
      return result.Body;
    } catch (error) {
      return error;
    }
  },
);
export const closingMagicLink = createAsyncThunk(
  'OccasionalCreditCardInput/closingMagicLink',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('closingMagicLink', [
        data.clientName,
        data.scopeName,
      ]);
      return result.Body;
    } catch (error) {
      return error;
    }
  },
);
const initialState = {
  currentProgramStep: ProgramSteps.MAIN,
  mlOpportunityId:null,
  isLoading: false,
  isNextPhaseBtnPressed: false,
  blackListValidationInfo: {
    reqCompletedSuccessfully: false,
    reqCompletedWithError: false,
    data: null,
  },
  creditCardJetInfo: {
    reqCompletedSuccessfully: false,
    reqCompletedWithError: false,
  },
  closingMagicLinkInfo: {
    reqCompletedSuccessfully: false,
  },
};

const OccasionalCreditCardInputSlice = createSlice({
  name: 'OccasionalCreditCardInput',
  initialState: initialState,
  reducers: {
    setCurrentProgramStep: (state, action) => {
      state.currentProgramStep = action.payload;
      return state;
    },
    cleanSliceData:(state)=>{
      state=initialState;
      return state;
    },
    setNextPhaseBtnPressed: (state, action) => {
      state.isNextPhaseBtnPressed = action.payload;
      return state;
    },
    setMlOpportunityId:(state,action)=>{
      state.mlOpportunityId=action.payload;
      return state
    }
  },
  extraReducers: {
    [blackListValidation.pending]: (state) => {
      state.isLoading = true;
      state.blackListValidationInfo.data = null;
      state.blackListValidationInfo.reqCompletedSuccessfully = false;
      state.blackListValidationInfo.reqCompletedWithError = false;
    },
    [blackListValidation.fulfilled]: (state, action) => {
        state.isLoading = false;
        const data = action.payload?.Body?.response;
        const isSuccessResponse = data?.pym_Black_List_Ind && data?.delinquent_Customers_Ind;

        if (isSuccessResponse) {
          state.blackListValidationInfo.data = data;
          state.blackListValidationInfo.reqCompletedSuccessfully = true;
          state.blackListValidationInfo.reqCompletedWithError = false;
        } else {
          state.blackListValidationInfo.data = null;
          state.blackListValidationInfo.reqCompletedSuccessfully = false;
          state.blackListValidationInfo.reqCompletedWithError = true;
        }
    },
    [blackListValidation.rejected]: (state) => {
      state.isLoading = false;
      state.blackListValidationInfo.data = null;
      state.blackListValidationInfo.reqCompletedSuccessfully = false;
      state.blackListValidationInfo.reqCompletedWithError = true;
    },
    [jetUpdateOpportunityCreditCard.pending]: (state) => {
      state.isLoading = true;
      state.creditCardJetInfo.reqCompletedSuccessfully = false;
      state.creditCardJetInfo.reqCompletedWithError = false;
    },
    [jetUpdateOpportunityCreditCard.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload?.Header?.returnCode === '00') {
        state.creditCardJetInfo.reqCompletedSuccessfully = true;
        state.creditCardJetInfo.reqCompletedWithError = false;
      } else {
        state.creditCardJetInfo.reqCompletedSuccessfully = false;
        state.creditCardJetInfo.reqCompletedWithError = true;
      }
    },
    [jetUpdateOpportunityCreditCard.rejected]: (state) => {
      state.isLoading = false;
      state.creditCardJetInfo.reqCompletedSuccessfully = false;
      state.creditCardJetInfo.reqCompletedWithError = true;
    },
    [closingMagicLink.pending]: (state) => {
      state.closingMagicLinkInfo.reqCompletedSuccessfully = false;
    },
    [closingMagicLink.fulfilled]: (state, action) => {
      if (action.payload?.header?.returnCode === '0') {
        try {
          const isMagicLinkClosed = JSON.parse(action.payload?.body);
          if (isMagicLinkClosed) {
            const creditCardInfoMlObj = {
              isMagicLinkClosed: true,
              mlOpportunityId: state.mlOpportunityId,
            };
            sessionStorage.setItem('creditCardInfoMlObj', JSON.stringify(creditCardInfoMlObj));
          }
        } catch {}
        state.closingMagicLinkInfo.reqCompletedSuccessfully = true;
      } else {
        state.closingMagicLinkInfo.reqCompletedSuccessfully = false;
      }
    },
    [closingMagicLink.rejected]: (state) => {
      state.closingMagicLinkInfo.reqCompletedSuccessfully = false;
    },
  },
});

export const {setCurrentProgramStep,cleanSliceData,setNextPhaseBtnPressed,setMlOpportunityId} = OccasionalCreditCardInputSlice.actions;
export default OccasionalCreditCardInputSlice.reducer;
